export const triggerBrowserDownload = (blob, fileName) => {
  if (process.env.NODE_ENV === 'test') return;
  if (window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(blob, fileName);
    return;
  }
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  if (link?.parentNode?.removeChild) link.parentNode.removeChild(link);
};

export const parseFilename = (headers, defaultFileName) => {
  const header = headers?.['content-disposition'];
  if (!header) return defaultFileName;
  const match = header.split('filename=')[1];
  return match ? match.replace(/^"|"$/g, '') : defaultFileName;
};

export const downloadCsvResponse = (response, defaultFileName) =>
  triggerBrowserDownload(new Blob([response.data]), parseFilename(response.headers, defaultFileName));

export const readBlobText = blob =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(reader.error);
    reader.readAsText(blob);
  });

// Data rows in a CSV blob, excluding the header line. Quoted fields keep their
// newlines (escapeCsv), so quoted runs are stripped before counting line breaks.
export const csvRowCount = async blob => {
  const unquoted = (await readBlobText(blob)).replace(/"[^"]*"/g, '');
  const lineBreaks = (unquoted.match(/\n/g) || []).length;
  const rows = unquoted.length && !unquoted.endsWith('\n') ? lineBreaks + 1 : lineBreaks;
  return Math.max(rows - 1, 0);
};

// Same escaping the backend exports use (commons-text escapeCsv), so both report files read the same.
const NEEDS_QUOTING = /[",\n\r]/;

export const toCsvLine = cells =>
  `${cells.map(cell => (NEEDS_QUOTING.test(cell) ? `"${cell.replace(/"/g, '""')}"` : cell)).join(',')}\n`;
